var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtileblocktworowhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 4C30.6569 4 32 5.40197 32 7.13086V24.8691C32 26.544 30.7394 27.9123 29.1543 27.9961L29 28H3L2.8457 27.9961C1.26055 27.9123 0 26.544 0 24.8691V7.13086C0 5.40197 1.34315 4 3 4H29ZM3 6C2.55653 6 2.0653 6.37374 2.00586 7.00195L2 7.13086V24.8691C2 25.5745 2.52708 26 3 26H29C29.4729 26 30 25.5745 30 24.8691V7.13086C30 6.42546 29.4729 6 29 6H3ZM14 11C14.5523 11 15 11.4477 15 12V20C15 20.5523 14.5523 21 14 21H6C5.44772 21 5 20.5523 5 20V12C5 11.4477 5.44772 11 6 11H14ZM26 11C26.5523 11 27 11.4477 27 12V20C27 20.5523 26.5523 21 26 21H18C17.4477 21 17 20.5523 17 20V12C17 11.4477 17.4477 11 18 11H26Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtileblocktworowhover);
export default __webpack_public_path__ + "static/media/addtileblocktworowhover.3f4076fd.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtileblocktworowhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 4C30.6569 4 32 5.40197 32 7.13086V24.8691C32 26.544 30.7394 27.9123 29.1543 27.9961L29 28H3L2.8457 27.9961C1.26055 27.9123 0 26.544 0 24.8691V7.13086C0 5.40197 1.34315 4 3 4H29ZM3 6C2.55653 6 2.0653 6.37374 2.00586 7.00195L2 7.13086V24.8691C2 25.5745 2.52708 26 3 26H29C29.4729 26 30 25.5745 30 24.8691V7.13086C30 6.42546 29.4729 6 29 6H3ZM14 11C14.5523 11 15 11.4477 15 12V20C15 20.5523 14.5523 21 14 21H6C5.44772 21 5 20.5523 5 20V12C5 11.4477 5.44772 11 6 11H14ZM26 11C26.5523 11 27 11.4477 27 12V20C27 20.5523 26.5523 21 26 21H18C17.4477 21 17 20.5523 17 20V12C17 11.4477 17.4477 11 18 11H26Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtileblocktworowhover);
export default __webpack_public_path__ + "static/media/addtileblocktworowhover.3f4076fd.svg";
export { ForwardRef as ReactComponent };